import i18next from 'i18next';

i18next.addResources('en', 'FORGOT_PASSWORD', {
  TITLE: 'Forgot your password?',
  SUBTITLE: 'Enter your email address and we will send you instructions to reset it.',
  EMAIL: 'Email address',
  SUBMIT_BUTTON: 'Send reset link',
  LOADING: 'Loading...',
});

i18next.addResources('es', 'FORGOT_PASSWORD', {
  TITLE: '¿Olvidaste tu contraseña?',
  SUBTITLE: 'Ingresá tu correo electrónico y te enviaremos las instrucciones para restablecerla.',
  EMAIL: 'Correo electrónico',
  SUBMIT_BUTTON: 'Enviar enlace de recuperación',
  LOADING: 'Cargando...',
});
